/**
 * @author Sufiyan momin
 * @description Add character count to input
 * for example <input class="form-control" type="text" placeholder="Type here"
 * name="firstFormName" ng-model="userInfoData.first_name"
 * ng-maxlength="50" char-count warning-count="10" danger-count="5">
 */

app.directive('charCount', ['$parse', '$compile', '$translate', function ($parse, $compile, $translate) {
    var templateFull = "<p class='{{ class }}'>" + "{{ wordsCount }} {{'mots' | translate}} | {{ charCount }} {{'deCompteur' | translate}} {{ maxLengthck }} {{'caracteres' | translate}}" +
        "</p>";
    var templateCompact = "<p class='{{ class }}'>" + "{{ wordsCount }} {{'mots' | translate}} | {{ charCount }} {{'caracteres' | translate}}" +
        "</p>";
    var getTemplateHtml = function (contentType) {

        var template = '';

        switch (contentType) {
            case 'Full':
                template = templateFull;
                break;
            case 'Compact':
                template = templateCompact;
                break;
        }

        return template;
    };

    return {
        scope: {
            'ngModel': '=',
            'maxLengthck': '=',
            'warningCount': '=',
            'dangerCount': '='
        },

        link: function (scope, element) {
            scope.class = 'normalCharacter';
            scope.wordsCount = 0;
            scope.charCount = 0;

            //dynamiser template selon la limit maxLengthck
            if (scope.maxLengthck > 0) {
                element.html(getTemplateHtml('Full'));
            }
            else {
                element.html(getTemplateHtml('Compact'));
            }
            $compile(element.contents())(scope);

            scope.$watch(
              'ngModel',
              function (newValue) {
                  if (angular.isDefined(newValue)) {
                      scope.wordsCount = parseInt(getPlainWordCount(newValue));
                      scope.charCount = parseInt(getPlainCharCount(newValue));

                      if (scope.maxLengthck > 0) {
                          if (scope.charCount > (scope.maxLengthck - scope.dangerCount)) {
                              scope.class = 'dangerCharacter';
                          }
                          else if (scope.charCount > (scope.maxLengthck - scope.warningCount)) {
                              scope.class = 'warningCharacter';
                          }
                          else {
                              scope.class = 'normalCharacter';
                          }
                      }
                      else {
                          scope.class = 'normalCharacter';
                      }
                  }
              }
              );
        }
    };
}]);